import * as types from '../../../lib/actionTypes.es6';

var initialState = {
  list: [], loading: false, error: null,
  creating: false, created: null, createError: null,
  updating: false, updated: null, updateError: null,
  deleting: false, deleted: null, deleteError: null,
};

export default function orgClaimInitConfigsReducer(state, action) {
  if (state === undefined) { state = initialState; }
  switch (action.type) {
    case types.GET_ORG_CLAIM_INIT_CONFIGS_REQUEST:
      return Object.assign({}, state, { loading: true, error: null, list: [] });
    case types.GET_ORG_CLAIM_INIT_CONFIGS_SUCCESS:
      return Object.assign({}, state, { loading: false, list: action.payload });
    case types.GET_ORG_CLAIM_INIT_CONFIGS_FAILURE:
      return Object.assign({}, state, { loading: false, error: action.payload });
    case types.CREATE_ORG_CLAIM_INIT_CONFIG_REQUEST:
      return Object.assign({}, state, { creating: true, created: null, createError: null });
    case types.CREATE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { creating: false, created: action.payload });
    case types.CREATE_ORG_CLAIM_INIT_CONFIG_FAILURE:
      return Object.assign({}, state, { creating: false, createError: action.payload });
    case types.RESET_CREATE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { created: null });
    case types.RESET_CREATE_ORG_CLAIM_INIT_CONFIG_ERROR:
      return Object.assign({}, state, { createError: null });
    case types.UPDATE_ORG_CLAIM_INIT_CONFIG_REQUEST:
      return Object.assign({}, state, { updating: true, updated: null, updateError: null });
    case types.UPDATE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { updating: false, updated: action.payload });
    case types.UPDATE_ORG_CLAIM_INIT_CONFIG_FAILURE:
      return Object.assign({}, state, { updating: false, updateError: action.payload });
    case types.RESET_UPDATE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { updated: null });
    case types.RESET_UPDATE_ORG_CLAIM_INIT_CONFIG_ERROR:
      return Object.assign({}, state, { updateError: null });
    case types.DELETE_ORG_CLAIM_INIT_CONFIG_REQUEST:
      return Object.assign({}, state, { deleting: true, deleted: null, deleteError: null });
    case types.DELETE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { deleting: false, deleted: true });
    case types.DELETE_ORG_CLAIM_INIT_CONFIG_FAILURE:
      return Object.assign({}, state, { deleting: false, deleteError: action.payload });
    case types.RESET_DELETE_ORG_CLAIM_INIT_CONFIG_SUCCESS:
      return Object.assign({}, state, { deleted: null });
    case types.RESET_DELETE_ORG_CLAIM_INIT_CONFIG_ERROR:
      return Object.assign({}, state, { deleteError: null });
    default:
      return state;
  }
}
